/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetTokenForIdRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetTokenForIdResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetTokenForId = (request: BatchGetTokenForIdRequest, options?: CashRequestOptions) => post<BatchGetTokenForIdRequest, BatchGetTokenForIdResponse>("/2.0/cash/batch-get-token-for-id", request, {...options, rejectOnError: true })